// extracted by mini-css-extract-plugin
export default {"unitpage":"unitpage_unitpage__+BhwE"};